import dxInterceptionApi from "services/dxInterception.api";
import { diagnosisInfo, updateDiagnosisInfo } from "dto/encounter.dto";

const updateDiagnosis = (id: string, payload: updateDiagnosisInfo) => {
    return dxInterceptionApi.put(`/encounters/${id}/diagnosis`, payload);
};

const getDiagnosis = async (id: string) => {
    return dxInterceptionApi.get<diagnosisInfo>(`/encounters/${id}/diagnosis`);
};

const diagnosisService = { updateDiagnosis, getDiagnosis };

export default diagnosisService;
